/**
 * Backend sometimes serializes Vavr Lists as nested {head, tail} objects
 * (or a JSON string of that shape) instead of a plain string[].
 * Normalize any of those shapes into a clean URL string array.
 */
const collectUrls = (node, out) => {
  if (node == null) return out;

  if (typeof node === 'string') {
    const trimmed = node.trim();
    if (!trimmed) return out;
    if (
      trimmed.startsWith('{') ||
      trimmed.startsWith('[') ||
      trimmed.includes('io.vavr.collection.List')
    ) {
      try {
        return collectUrls(JSON.parse(trimmed), out);
      } catch {
        // fall through — treat as a plain URL string
      }
    }
    if (/^(https?:\/\/|\/)/i.test(trimmed)) out.push(trimmed);
    return out;
  }

  if (Array.isArray(node)) {
    node.forEach((item) => collectUrls(item, out));
    return out;
  }

  if (typeof node === 'object') {
    if (
      node._class === 'io.vavr.collection.List$Nil' ||
      node.empty === true
    ) {
      return out;
    }
    if ('head' in node || 'tail' in node) {
      collectUrls(node.head, out);
      collectUrls(node.tail, out);
      return out;
    }
  }

  return out;
};

export const normalizeFileUrls = (fileUrls, { preserveDuplicates = false } = {}) => {
  if (fileUrls == null) return [];
  const urls = collectUrls(fileUrls, []);
  return preserveDuplicates ? urls : [...new Set(urls)];
};

export const normalizeSubmissionFileUrls = (submission) => {
  if (!submission?.answers?.length) return submission;
  return {
    ...submission,
    answers: submission.answers.map((entry) => {
      if (!entry?.answer || entry.answer.fileUrls == null) return entry;
      return {
        ...entry,
        answer: {
          ...entry.answer,
          // A bulk answer pairs each URL with a source page index. Two pages
          // from the same PDF intentionally have the same URL.
          fileUrls: normalizeFileUrls(entry.answer.fileUrls, {
            preserveDuplicates: entry.answer.filePageIndexes?.length > 0,
          }),
        },
      };
    }),
  };
};
